export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package_planning_alert": {
            "real_num_packages": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_packages")), " paquetes registrados"])}
          }
        }
      },
      "en": {
        "model": {
          "package_planning_alert": {
            "real_num_packages": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("real_num_packages")), " packages registered"])}
          }
        }
      }
    }
  })
}